import React, { FC, PropsWithChildren } from "react";

import { Stack } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import HelpInfo from "../../../components/HelpInfo";
import { PplRule } from "../../../store/pomeriumApi";
import {
  addToggleCriterionToRules,
  hasToggleCriterion,
  removeToggleCriterionFromRules,
} from "../../../utils/ppl";
import PPLBlock from "./PPLBlock";

type TogglesProps = PropsWithChildren<{
  readonly: boolean;
  pplArr: PplRule[];
  savePPL(value: PplRule[]): void;
}>;
const Toggles: FC<TogglesProps> = ({ readonly, pplArr, savePPL }) => {
  return (
    <PPLBlock title="OVERRIDES">
      <Stack direction="row" justifyContent="space-around">
        <FormControlLabel
          control={
            <Switch
              checked={pplArr.some((r) => hasToggleCriterion(r, "accept"))}
              onChange={(_, checked): void => {
                savePPL(
                  checked
                    ? addToggleCriterionToRules(pplArr, "accept")
                    : removeToggleCriterionFromRules(pplArr, "accept"),
                );
              }}
              disabled={readonly}
            />
          }
          label={
            <Stack direction="row" alignItems="center" gap={0.5}>
              Public Access
              <HelpInfo docsKey="public-access" />
            </Stack>
          }
        />
        <FormControlLabel
          control={
            <Switch
              checked={pplArr.some((r) =>
                hasToggleCriterion(r, "cors_preflight"),
              )}
              onChange={(_, checked): void => {
                savePPL(
                  checked
                    ? addToggleCriterionToRules(pplArr, "cors_preflight")
                    : removeToggleCriterionFromRules(pplArr, "cors_preflight"),
                );
              }}
              disabled={readonly}
            />
          }
          label={
            <Stack direction="row" alignItems="center" gap={0.5}>
              CORS Preflight
              <HelpInfo docsKey="cors-preflight" />
            </Stack>
          }
        />
        <FormControlLabel
          control={
            <Switch
              checked={pplArr.some((r) =>
                hasToggleCriterion(r, "authenticated_user"),
              )}
              onChange={(_, checked): void => {
                savePPL(
                  checked
                    ? addToggleCriterionToRules(pplArr, "authenticated_user")
                    : removeToggleCriterionFromRules(
                        pplArr,
                        "authenticated_user",
                      ),
                );
              }}
              disabled={readonly}
            />
          }
          label={
            <Stack direction="row" alignItems="center" gap={0.5}>
              Any Authenticated User
              <HelpInfo
                docsKey="allow-any-authenticated-user"
                variant="warning"
                description="This setting ensures users have an authenticated user session. However, depending on the configured identity provider, this could be anyone in the world, or just your organization's directory pool. Authorization is assumed to happen in the upstream application. Use with caution."
              />
            </Stack>
          }
        />
      </Stack>
    </PPLBlock>
  );
};

export default Toggles;
